import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import {
	UserCompaniesClient,
	UserCompanyListDto,
} from 'app/core/services/api.service';
import { first } from 'rxjs';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { tapResponse } from '@ngrx/operators';
import { switchMap } from 'rxjs/operators';
import { pipe } from 'rxjs';

type MultiTenantState = {
	companies: UserCompanyListDto[];
};

const initialState: MultiTenantState = {
	companies: [],
};

export const MultiTenantStore = signalStore(
	{ providedIn: 'root' },

	withState(initialState),

	withMethods((store) => {
		const _userCompaniesClient = inject(UserCompaniesClient);

		return {
			setCompanies: (companies: UserCompanyListDto[]) => {
				patchState(store, { companies });
			},
			refreshCompanies: rxMethod<void>(
				pipe(
					switchMap(() => {
						return _userCompaniesClient.getUserCompanies();
					}),
					tapResponse({
						next: (companies: UserCompanyListDto[]) => {
							patchState(store, { companies });
						},
						error: (error) => {
							console.error('Error loading companies', error);
						},
					})
				)
			),
			signOff: () => {
				patchState(store, initialState);
			},
		};
	})
);
